export class ValidationError extends Error {
    code;
    constructor(msg, code) {
        super(msg);
        this.code = code;
    }
}
